// ==============================|| OVERRIDES - TABLE ROW ||============================== //

export default function TableBody(theme) {
  return {
    MuiTableBody: {
      styleOverrides: {
        root: {
          backgroundColor: theme.vars.palette.background.paper,
          '& .MuiTableRow-root': {
            '&:nth-of-type(even)': {
              backgroundColor: theme.vars.palette.grey[50]
            },
            '&:hover': {
              backgroundColor: theme.vars.palette.action.hover
            }
          }
        }
      }
    }
  };
}
